import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const locale = "sr";

export const studentAddressManagement = createApi({
    reducerPath: "studentAddressManagement",
    baseQuery: fetchBaseQuery({
        baseUrl: `${BASE_URL}`,
        prepareHeaders: (headers) => {
            const jwtToken = localStorage.getItem("userToken") || sessionStorage.getItem("userToken");

            if (jwtToken) {
                headers.set("authorization", `Bearer ${jwtToken}`);
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        studentAddressList: builder.mutation({
            query: (body) => {
                let url = `v1/${locale}/settings/student-address`;

                for (const property in body) {
                    if ((property && body[property]) || (property === "startPage" && body[property] === 0)) {
                        if (url?.includes("?")) {
                            url += `&${property}=${body[property]}`;
                        } else {
                            url += `?${property}=${body[property]}`;
                        }
                    }
                }

                return {
                    url: url,
                    method: "GET",
                };
            },
        }),
        viewStudentAddress: builder.mutation({
            query: (addressId) => ({
                url: `v1/${locale}/settings/student-address/${addressId}`,
                method: "GET",
            }),
        }),

        addStudentAddress: builder.mutation({
            query: (body) => ({
                url: `v1/${locale}/settings/student-address`,
                method: "POST",
                body: body,
            }),
        }),

        updateStudentAddress: builder.mutation({
            query: ({ body, addressId }) => ({
                url: `v1/${locale}/settings/student-address/${addressId}`,
                method: "PATCH",
                body: body,
            }),
        }),

        deleteStudentAddress: builder.mutation({
            query: (addressId) => ({
                url: `v1/${locale}/settings/student-address/${addressId}`,
                method: "DELETE",
            }),
        }),
    }),
});

export const {
    useAddStudentAddressMutation,
    useDeleteStudentAddressMutation,
    useStudentAddressListMutation,
    useUpdateStudentAddressMutation,
    useViewStudentAddressMutation
} = studentAddressManagement;
